import axios from "axios";
import config from "../../config";
import Cookies from "js-cookie";

const baseUrl = config.baseUrl; // URL base de tu API
const informePorProyectoEndpoint = "/api/informes/general-por-proyecto"; // Endpoint para el CRUD de bodegas

// Crear una instancia de Axios con la configuración base
const api = axios.create({
  baseURL: baseUrl,
});

// Interceptor de solicitud para añadir el token de autorización
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Función para obtener informacion del plan de compras de sostenibilidad
 * @returns {Promise<Object>} Respuesta con status y datos o mensaje de error
 */
export const getInformeGeneralPorProyecto = async () => {
  try {
    const response = await api.get(informePorProyectoEndpoint);
    return response.data;
  } catch (error) {
    console.error("Error al obtener la información:", error.message || error);
    return {
      status: error.response ? error.response.status : 500,
      message: error.message || "Error al obtener la información",
    };
  }
};
